import React, { useRef } from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import RegisteredMessageTemplate from '@components/chat/chatDetail/messageList/parentMessage/RegisteredMessageTemplate';
import DeadlineMessageTemplate from '@components/chat/chatDetail/messageList/parentMessage/DeadlineMessageTemplate';
import { AdminMessage } from '@domain/constant/AdminMessageType';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ParentMessageProps {
  type?: 'me' | 'other' | 'admin';
  id?: string;
  message?: Message | undefined;
}

const ParentMessage = ({ type = 'other', id, message }: ParentMessageProps) => {
  const ref = useRef<null | HTMLSpanElement>(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const isMessage = !!message?.id || id !== '';

  const getUserName = () => {
    if (message?.type === 'admin') return '📢JOBDA';
    return message?.username;
  };

  const getMessage = () => {
    if (message?.type === 'admin') {
      switch (message?.data?.type) {
        case AdminMessage.REMIND_JOB_POSTING_DEADLINE_D_DAY:
          return '[D-Day] 입사지원 마감 안내 ⏰';
        case AdminMessage.REMIND_JOB_POSTING_DEADLINE_D_3:
          return '[D-3] 입사지원 마감 안내 ⏰';
        case AdminMessage.REMIND_JOB_POSTING_DEADLINE:
          return <DeadlineMessageTemplate message={message} />;
        case AdminMessage.REMIND_JOB_POSTING_REGISTERED:
          return <RegisteredMessageTemplate message={message} />;
      }
    }

    if (!message && id) return '삭제된 메시지입니다.';

    return message?.text || '';
  };

  // 말줄임이 필요한지, 아닌지 판단하는 함수
  const isEllipsisNeeded = (): boolean => {
    // if (message?.type === 'admin') return true;
    const textElement = ref.current;
    if (!textElement) return false;
    return textElement.scrollHeight > textElement.clientHeight;
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  if (!isMessage) return null;
  return (
    <div className={cx('messageArea', type, { fold: !isOpen })}>
      {message?.username && <span className={cx('name')}>{getUserName()} :</span>}
      <span ref={ref} className={cx('message')}>
        {getMessage()}
      </span>
      {!isOpen && isEllipsisNeeded() && (
        <button className={cx('btn')} onClick={handleOpen}>
          더보기
        </button>
      )}
    </div>
  );
};

export default ParentMessage;
